import { createAction, props } from '@ngrx/store';
import { App, AppBinary, HistoryStatus, QueueItem, Tag, TagChanges, TestPush, UserInfo } from './app.models';
// App
export const resetState = createAction('[App] reset state');

// Contract
export const fetchContract = createAction('[Contract] fetch start');
export const fetchContractSuccess = createAction('[Contract] fetch success', props<{ payload: any }>());
export const chooseContract = createAction('[Contract] Choose', props<{ payload: string }>());
export const fetchContractEndpoints = createAction('[Contract] fetch endpoints', props<{ baseUrl: string }>());
export const fetchContractEndpointsSuccess = createAction('[Contract] fetch endpointsSuccess', props<{ payload: any }>());

// customer
export const fetchCustomer= createAction('[Customer] fetch start');
export const fetchCustomerSuccess = createAction('[Customer] fetch success', props<{ payload: any }>());

// Userinfo cognito
export const logout = createAction('[UserInfo] logout');
export const logoutSuccess = createAction('[UserInfo] logout success');
export const fetchUserInfo = createAction('[UserInfo] fetch start', props<{ payload: string }>());
export const fetchUserInfoSuccess = createAction('[UserInfo] fetch success', props<{ payload: UserInfo }>());

// apps
export const fetchApps = createAction('[Apps] fetch start');
export const fetchAppsSuccess = createAction('[Apps] fetch success', props<{ payload: App[] }>());
export const createApp = createAction('[Apps] create start', props<{ payload: { app: App, icon?: File, files?: AppBinary[] } }>());
export const createAppSuccess = createAction('[Apps] create success', props<{ payload: { app: App } }>());
export const updateApp = createAction('[Apps] update start', props<{ payload: { app: App, icon?: File, files?: AppBinary[] } }>());
export const updateAppSuccess = createAction('[Apps] update success', props<{ payload: { app: App } }>());
export const deleteApp = createAction('[Apps] delete start', props<{ payload: App }>());
export const deleteAppSuccess = createAction('[Apps] delete success');
export const assignTags = createAction('[Apps] assign Tags', props<{ payload: { app: App, changes: TagChanges[] } }>());
export const addTagToApp = createAction('[Apps] add Tag', props<{ payload: { appid: number, tagid: number } }>());
export const addTagToAppSuccess = createAction('[Apps] add tag success', props<{ payload: { app: App } }>());
export const deleteTagFromApp = createAction('[Apps] delete tag', props<{ payload: { appid: number, tagid: number } }>());
export const deleteTagFromAppSuccess = createAction('[Apps] delete tag success', props<{ payload: { app: App } }>());

// tags
export const fetchTags = createAction('[Tags] fetch start');
export const fetchTagsSuccess = createAction('[Tags] fetch success', props<{ payload: Tag[] }>());
export const createTag = createAction('[Tags] create start', props<{ payload: Tag }>());
export const createTagsSuccess = createAction('[Tags] create success', props<{ payload: Tag }>());
export const updateTag = createAction('[Tags] update start', props<{ payload: Tag }>());
export const updateTagSuccess = createAction('[Tags] update success', props<{ payload: Tag }>());
export const deleteTag = createAction('[Tags] delete start', props<{ payload: Tag }>());
export const deleteTagSuccess = createAction('[Tags] delete success');

// push
export const sendTestPush = createAction('[Testpush] send start', props<{ payload: TestPush }>());
export const sendTestPushSuccess = createAction('[Testpush] send success');

// history
export const fetchHistory = createAction('[History ] fetch start');
export const fetchHistorySuccess = createAction('[History ] fetch success', props<{ payload: History[] }>());

// queue
export const createQueueItem = createAction('[Queue] create item start', props<{ payload: QueueItem }>());
export const fetchQueueStats = createAction('[Queue] fetch stats start', props<{ payload: string }>());
export const fetchQueueStatsSuccess = createAction('[Queue] fetch stats success', props<{ payload: {resp: HistoryStatus[], jobid: string} }>());

// export const createQueueItemSuccess = createAction('[Queue] create success', props<{ payload: Tag }>());
